'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var reactRouterDom = require('react-router-dom');
var styled = require('styled-components');
var components_Title1_index = require('../Title1/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var LinkText = styled__default["default"](components_Title1_index["default"])(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  padding: 13px 40px;\n  display: inline-block;\n"], ["\n  padding: 13px 40px;\n  display: inline-block;\n"])));
var Underline = styled__default["default"].div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  border-radius: 7px;\n  width: 100%;\n  background-color: ", ";\n  height: 3px;\n"], ["\n  border-radius: 7px;\n  width: 100%;\n  background-color: ", ";\n  height: 3px;\n"])), function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
});
var NavigationLink = styled__default["default"](reactRouterDom.NavLink).attrs({ end: true })(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: inline-block;\n  ", " {\n    visibility: hidden;\n  }\n\n  ", " {\n    color: ", ";\n  }\n  :hover {\n    ", " {\n      color: ", ";\n    }\n  }\n  &.is-active {\n    ", " {\n      visibility: visible;\n    }\n    ", " {\n      color: ", ";\n    }\n  }\n"], ["\n  display: inline-block;\n  ", " {\n    visibility: hidden;\n  }\n\n  ", " {\n    color: ", ";\n  }\n  :hover {\n    ", " {\n      color: ", ";\n    }\n  }\n  &.is-active {\n    ", " {\n      visibility: visible;\n    }\n    ", " {\n      color: ", ";\n    }\n  }\n"])), Underline, LinkText, function (_a) {
    var secondary = _a.theme.colors.text.secondary;
    return secondary;
}, LinkText, function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
}, Underline, LinkText, function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
});
var TabItem = function (_a) {
    var to = _a.to, active = _a.active, children = _a.children;
    return (React__default["default"].createElement(NavigationLink, { className: active ? 'is-active' : '', to: to },
        React__default["default"].createElement(LinkText, null, children),
        React__default["default"].createElement(Underline, null)));
};
var templateObject_1, templateObject_2, templateObject_3;

exports["default"] = TabItem;
